<template>
    <div class="SiteImgText">
        <img :src="img">

        <div class="main">
            <span v-if="tag">{{ tag }}</span>
            <h2 v-if="title">{{ title }}</h2>
            <p v-if="description">{{ description }}</p>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SiteImgText',

    props: {
        tag: { type: String, default: '' },
        title: { type: String, default: '' },
        description: { type: String, default: '' },
        img: { type: String, required: true },
    },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.SiteImgText {
    display: flex;
    justify-content: space-between;
    padding: 60px 0;

    @include breakpoint(md) {
        flex-direction: column-reverse !important;
        justify-content: center;
        text-align: center;
    }

    img {
        align-self: center;
        width: 100%;
        max-width: 400px;

        @include breakpoint(md) {
            margin: 60px auto 0;
        }
    }

    .main {
        margin-top: 30px;
        max-width: 500px;

        @include breakpoint(md) {
            margin: 0 auto;
        }

        span {
            font-size: 18px;
            text-transform: uppercase;
        }

        h2 {
            @extend %display-subtitle;
            margin: 30px 0;
        }

        p {
            @extend %display-description;
        }
    }

    &.reverse {
        flex-direction: row-reverse;
    }

    &.shadow img {
        border-radius: 8px;
        box-shadow: $shadow-spread;
    }
}
</style>
